import { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Input } from '@nazka/nazka.mapframe.components';

import EditableImage from '@App/components/EditableImage/EditableImage';
import { useAdaptationPlans, useAdaptationStories } from '@services/query.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { getImageUrl } from '@services/utils.service';
import { useUpdateAdaptationStory } from '@services/mutation.service';

import AdminEditStoryForm from './AdminEditStoryForm/AdminEditStoryForm';
import AdminMap from '../AdminMap/AdminMap';
import AdminStatusBadge from '../AdminStatusBadge/AdminStatusBadge';

import './admin-edit-story.styl';

function AdminEditStory() {
  const [updatedImage, setUpdatedImage] = useState();

  const { t } = useTranslation();
  
  const { data: stories } = useAdaptationStories();
  const { data: adaptationPlans } = useAdaptationPlans();

  const { id } = useParams();
  const navigate = useNavigate();

  const story = useMemo(() => stories?.find(s => s.id === id), [id, stories]);

  const updateStoryMutation = useUpdateAdaptationStory();

  function handleSubmit(payload) {
    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (['translations', 'hazardCategories'].includes(key)) {
        formData.append(key, JSON.stringify(payload[key]));
      } else {
        formData.append(key, payload[key]);
      }
    });

    if (updatedImage) {
      formData.append('image', updatedImage, updatedImage.name);
    }

    updateStoryMutation.mutate({
      id,
      data: formData,
    });
  }

  if (!story) {
    return null;
  }

  return (
    <div className="admin-edit-story">
      <h2>
        {t('Edit - {{title}}', { title: story.translations.en.title })}
        <AdminStatusBadge status={story.status} />
      </h2>
      <div className="admin-edit-story__content">
        <AdminEditStoryForm
          story={story}
          availablePlans={adaptationPlans}
          onSuccess={handleSubmit}
          onCancel={() => navigate('/admin/stories')}
          isPending={updateStoryMutation.isPending}
        /> 
        <div className="admin-edit-story__content__rest">
          <div className="admin-edit-story__content__rest__field">
            <label htmlFor="creatorName">
              {t('Name of creator')}
            </label>
            <Input
              disabled
              rootElProps={{
                id: 'creatorName',
              }}
              value={story.creatorName}
            />
          </div>
          <div className="admin-edit-story__content__rest__field">
            <label htmlFor="address">
              {t('Story address')}
            </label>
            <Input
              disabled
              rootElProps={{
                id: 'address',
              }}
              value={story.address}
            />
          </div>
          <AdminMap item={story} />
          <EditableImage
            src={getImageUrl(story)}
            alt={story.translations.en.title}
            onImageChange={file => setUpdatedImage(file)}
          />
        </div>
      </div>
    </div>
  );
}

export default AdminEditStory;